import { InvoiceStateCounterByServiceDelivery } from "../domain/InvoiceStateCounterByServiceDelivery";
import { StateCounterRepository } from "../domain/StateCounterRepository";
import { client } from "../../../api/client";

export class APIStateCounterRepository implements StateCounterRepository {
  async get_data(sd_id): Promise<{[key: string]: string[] | InvoiceStateCounterByServiceDelivery[]} > {
    return await client
      .post(`query/`,{query:'state.counter',args:{sd_id:sd_id}})
      .then((response) => response.data);
  }
}
